module.exports = __webpack_public_path__ + "static/media/johnny.f49970ea.png";